// The API base is read at build time. A deployment sets REACT_APP_API_URL; the
// fallback keeps the historical default so nothing else changes.
export default {
    dev: {
        server: process.env.REACT_APP_API_URL || 'https://api.wcaquino.me'
    }
};



// WEBPACK FOOTER //
// ./src/config/ambienteConfig.js